function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import BaseModule from './BaseModule';

var Resize = /*#__PURE__*/function (_BaseModule) {
  _inherits(Resize, _BaseModule);

  var _super = _createSuper(Resize);

  function Resize() {
    _classCallCheck(this, Resize);

    return _super.apply(this, arguments);
  }

  _createClass(Resize, [{
    key: "onCreate",
    value: function onCreate() {
      // track resize handles
      this.boxes = []; // add 4 resize handles

      this.addBox('nwse-resize'); // top left

      this.addBox('nesw-resize'); // top right

      this.addBox('nwse-resize'); // bottom right

      this.addBox('nesw-resize'); // bottom left

      this.positionBoxes();
    }
  }, {
    key: "onDestroy",
    value: function onDestroy() {
      // reset drag handle cursors
      this.setCursor('');
    }
  }, {
    key: "positionBoxes",
    value: function positionBoxes() {
      var _this = this;

      var handleXOffset = "".concat(-parseFloat(this.options.styles.handle.width) / 2, "px");
      var handleYOffset = "".concat(-parseFloat(this.options.styles.handle.height) / 2, "px") // set the top and left for each drag handle
      ;
      [{
        left: handleXOffset,
        top: handleYOffset
      }, // top left
      {
        right: handleXOffset,
        top: handleYOffset
      }, // top right
      {
        right: handleXOffset,
        bottom: handleYOffset
      }, // bottom right
      {
        left: handleXOffset,
        bottom: handleYOffset
      } // bottom left
      ].forEach(function (pos, idx) {
        Object.assign(_this.boxes[idx].style, pos);
      });
    }
  }, {
    key: "addBox",
    value: function addBox(cursor) {
      // create div element for resize handle
      var box = document.createElement('div'); // Star with the specified styles

      Object.assign(box.style, this.options.styles.handle);
      box.style.cursor = cursor; // Set the width/height to use 'px'

      box.style.width = "".concat(this.options.styles.handle.width, "px");
      box.style.height = "".concat(this.options.styles.handle.height, "px"); // listen for mousedown on each box

      box.addEventListener('mousedown', this.handleMousedown.bind(this), false); // add drag handle to document

      this.overlay.appendChild(box); // keep track of drag handle

      this.boxes.push(box);
    }
  }, {
    key: "handleMousedown",
    value: function handleMousedown(evt) {
      var _this2 = this;

      this.blot.handling && this.blot.handling(true); // note which box

      this.dragBox = evt.target; // note starting mousedown position

      this.dragStartX = evt.clientX;
      this.dragStartY = evt.clientY; // store the width before the drag

      this.preDragSize = {
        width: this.activeEle.offsetWidth,
        height: this.activeEle.offsetHeight
      }; // store the natural size

      this.naturalSize = this.getNaturalSize(); // set the proper cursor everywhere

      this.setCursor(this.dragBox.style.cursor);

      this.handleDragProxy = function (evt) {
        return _this2.handleDrag(evt);
      };

      this.handleMouseupProxy = function (evt) {
        return _this2.handleMouseup(evt);
      }; // listen for movement and mouseup


      document.addEventListener('mousemove', this.handleDragProxy, false);
      document.addEventListener('mouseup', this.handleMouseupProxy, false);
    }
  }, {
    key: "handleMouseup",
    value: function handleMouseup() {
      // reset cursor everywhere
      this.setCursor('');
      this.blot.handling && this.blot.handling(false); // stop listening for movement and mouseup

      document.removeEventListener('mousemove', this.handleDragProxy);
      document.removeEventListener('mouseup', this.handleMouseupProxy);
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(evt) {
      var _this3 = this;

      if (!this.activeEle || !this.blot) {
        // activeEle not set yet
        return;
      } // update size


      var deltaX = evt.clientX - this.dragStartX;
      var deltaY = evt.clientY - this.dragStartY;
      var options = this.options.parchment[this.blot.statics.blotName];
      var size = {};
      var direction = 1;
      (options.attribute || ['width']).forEach(function (key) {
        size[key] = _this3.preDragSize[key];
      }); // left-side

      if (this.dragBox === this.boxes[0] || this.dragBox === this.boxes[3]) {
        direction = -1;
      }

      if (size.width) {
        size.width = Math.round(this.preDragSize.width + deltaX * direction);
      }

      if (size.height) {
        size.height = Math.round(this.preDragSize.height + deltaY * direction);
      }

      Object.assign(this.activeEle.style, this.calcSize(size, options.limit));
      this.requestUpdate();
    }
  }, {
    key: "calcSize",
    value: function calcSize(size) {
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var width = size.width,
          height = size.height; // keep ratio

      if (limit.ratio) {
        var limitHeight;
        if (limit.minWidth) width = Math.max(limit.minWidth, width);
        if (limit.maxWidth) width = Math.min(limit.maxWidth, width);
        height = width * limit.ratio;

        if (limit.minHeight && height < limit.minHeight) {
          limitHeight = true;
          height = limit.minHeight;
        }

        if (limit.maxHeight && height > limit.maxHeight) {
          limitHeight = true;
          height = limit.maxHeight;
        }

        if (limitHeight) {
          width = height / limit.ratio;
        }
      } else {
        if (size.width) {
          if (limit.minWidth) width = Math.max(limit.minWidth, width);
          if (limit.maxWidth) width = Math.min(limit.maxWidth, width);
        }

        if (size.height) {
          if (limit.minHeight) height = Math.max(limit.minHeight, height);
          if (limit.maxHeight) height = Math.min(limit.maxHeight, height);
        }
      }

      if (width) size.width = width + 'px';
      if (height) size.height = height + 'px';
      return size;
    }
  }, {
    key: "getNaturalSize",
    value: function getNaturalSize() {
      var ele = this.activeEle;
      var size = [0, 0];

      if (!ele.getAttribute('data-size')) {
        size = [ele.naturalWidth || ele.offsetWidth, ele.naturalHeight || ele.offsetHeight];
        ele.setAttribute('data-size', size[0] + ',' + size[1]);
      } else {
        size = ele.getAttribute('data-size').split(',');
      }

      return {
        width: parseInt(size[0]),
        height: parseInt(size[1])
      };
    }
  }, {
    key: "setCursor",
    value: function setCursor(value) {
      [document.body, this.activeEle].forEach(function (el) {
        el.style.cursor = value; // eslint-disable-line no-param-reassign
      });
    }
  }]);

  return Resize;
}(BaseModule);

export { Resize as default };